import { Grid, Typography } from '@mui/material'
import { FormType } from '../utils/sharedTypes'
import { funders } from '../utils/constants'

type Props = {
  form: FormType
}

export default function FundingSummaryFIFPL({ form }: Props) {
  const hasProducts = form.data.products.length > 0 && form.data.product === null
  const listing_price = hasProducts
    ? form.data.funding_organism_registrations.filter((r) => !r.cancelled).reduce((acc, r) => acc + r.product_listing_price, 0)
    : form.data.product
    ? form.data.product.listing_price
    : 0

  return form.data.personal_funding ? (
    <Grid item>
      <Grid item container direction="row" justifyContent="space-between" wrap="nowrap">
        <Grid item>
          <Typography variant="body2">Prix de la formation</Typography>
        </Grid>
        <Typography variant="body1" sx={{ textAlign: 'right', fontWeight: 500 }}>
          {Intl.NumberFormat('fr-FR', {
            style: 'currency',
            currency: 'EUR',
            maximumFractionDigits: 2,
          }).format(
            (form.data.product_catalog?.funding_price ?? form.data.product_catalog?.listing_price ?? listing_price) +
              form.data.personal_funding,
          ) || '-'}
        </Typography>
      </Grid>

      <Grid item container direction="row" justifyContent="space-between" wrap="nowrap">
        <Grid item>
          <Typography variant="body2">
            Montant pris en charge par le{' '}
            {funders.find((p) => p.code === form.data.funding_organism?.code)?.label || '-'}
          </Typography>
          {['FIFPL', 'FAFPM'].includes(form.data.funding_organism?.code ?? '') && (
            <Typography variant="caption">
              Cette prise en charge par le {form.data.funding_organism?.code === 'FAFPM' ? 'FAFPM' : 'FIF-PL'} est
              conditionnée par la validation de la formation et par l'existence d'un budget suffisant.
            </Typography>
          )}
        </Grid>
        <Typography variant="body1" sx={{ textAlign: 'right', textDecorationLine: 'line-through', fontWeight: 500 }}>
          {Intl.NumberFormat('fr-FR', {
            style: 'currency',
            currency: 'EUR',
            maximumFractionDigits: 2,
          }).format(
            form.data.product_catalog?.funding_price ?? form.data.product_catalog?.listing_price ?? listing_price,
          ) || '-'}
        </Typography>
      </Grid>

      <Grid item container direction="row" justifyContent="space-between" wrap="nowrap">
        <Grid item>
          <Typography variant="body2">Reste à charge</Typography>
        </Grid>
        <Typography variant="body1" sx={{ textAlign: 'right', fontWeight: 500 }}>
          {Intl.NumberFormat('fr-FR', {
            style: 'currency',
            currency: 'EUR',
            maximumFractionDigits: 2,
          }).format(form.data.personal_funding) || '-'}
        </Typography>
      </Grid>
    </Grid>
  ) : (
    <Grid item container direction="row" justifyContent="space-between" wrap="nowrap">
      <Grid item>
        <Typography variant="body2">Prix de la formation</Typography>
        <Typography variant="caption">
          Cette prise en charge par le {form.data.funding_organism?.code === 'FAFPM' ? 'FAFPM' : 'FIF-PL'} est
          conditionnée par la validation de la formation et par l'existence d'un budget suffisant.
        </Typography>
      </Grid>
      <Typography variant="body1" sx={{ textAlign: 'right', textDecorationLine: 'line-through', fontWeight: 500 }}>
        {Intl.NumberFormat('fr-FR', {
          style: 'currency',
          currency: 'EUR',
          maximumFractionDigits: 0,
        }).format(
          form.data.product_catalog?.funding_price ?? form.data.product_catalog?.listing_price ?? listing_price,
        ) || '-'}
      </Typography>
    </Grid>
  )
}
